<template>
  <b-card>
    <b-card-header>{{ selectedVendor.name }} Bank Info</b-card-header>
    <b-card-body>
      <b-row>
        <b-col sm="12">
          <label>Acc Holder Name</label>
          <b-input v-model="bank_info.account_holder_name"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Account Number</label>
          <b-input v-model="bank_info.account_number"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Ifsc Code</label>
          <b-input v-model="bank_info.ifsc_code"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Bank Name</label>
          <b-input v-model="bank_info.bank_name"></b-input>
        </b-col>
        <b-col class="mt-3" sm="12">
          <label>Documents</label>
          <template>
            <!-- <b-button
              class="ml-2"
              size="sm"
              @click="() => form.documents.push('')"
              ><i class="fa fa-plus-square"></i
            ></b-button> -->
            <b-col sm="8">
              <b-form-file
                multiple
                :key="fileKey"
                accept="pdf/*|image/*"
                @change="saveDocument"
              ></b-form-file>
            </b-col>
            <b-row>
              <b-col
                class="border border-2 p-2 m-2"
                sm="4"
                v-for="(dc, doc) in bank_info.documents"
                :key="doc"
              >
                <a target="_blank" :href="cdn + '/' + dc" class="mr-2">
                  <b-img
                    height="60"
                    :src="cdn + '/' + dc"
                    v-if="!dc.includes('pdf')"
                  ></b-img>
                  <p v-else>{{ dc }}</p>
                </a>
                <b-button size="sm" @click="deleteDocument(doc)"
                  ><i class="fa fa-trash"></i
                ></b-button>
              </b-col>
            </b-row>
          </template>
        </b-col>
        <b-col sm="12">
          <b-button @click="saveInfo" variant="success" class="mt-4"
            >Save</b-button
          >
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from "axios";
import { VENDORS_PATH } from "@/path";
import Swal from "sweetalert2";
import { ImagesPath } from "../../../../path";

export default {
  name: "bank-info",
  props: ["selectedVendor"],
  data() {
    return {
      cdn: process.env.VUE_APP_AWS_CDN,
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      bank_info: {
        vendor_id: this.selectedVendor.id,
        documents: [],
      },
      fileKey: 1,
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  mounted() {
    this.getVendors();
  },
  methods: {
    async getVendors() {
      try {
        let response = await axios.get(
          this.base_url + VENDORS_PATH.GET_BANK_DETAILS,
          {
            params: {
              vendor_id: this.selectedVendor.id,
            },
          }
        );
        if (response.data.status == true && response.data.data.length > 0) {
          this.bank_info = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveInfo() {
      try {
        let res = await axios.post(
          this.baseUrl + VENDORS_PATH.SAVE_BANK_DETAILS,
          this.bank_info
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
        } else {
          Swal.fire("error", "", "error");
        }
        this.$bvModal.hide("bv-set-vendor-bank-info");
        this.$emit("update");
      } catch (e) {
        console.log(e);
      }
    },
    async saveDocument(e) {
      try {
        let formData = new FormData();
        formData.append("file", e.target.files[0]);
        formData.append("folder", "items");
        let res = await axios.post(
          this.baseUrl + ImagesPath.UPLOAD_IMAGE,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status) {
          this.bank_info.documents.push(res.data.data.file);
          this.fileKey += 1;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteDocument(v) {
      try {
        this.bank_info.documents.splice(v, 1);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style scoped></style>
